import React from 'react';
import { render } from 'react-dom';
import LanguageSwitch from '../render/LanguageSwitch';
import CurrencySwitch from '../render/CurrencySwitch';

export default class Header {
  constructor(context) {
    this.context = context;

    this.levelToggles = [...this.context.querySelectorAll('[data-header="level-toggle"]')];
    this.thirdLevelToggles = [
      ...this.context.querySelectorAll('[data-header="third-level-toggle"]'),
    ];
    this.navigation = this.context.querySelector('[data-header="navigation"]');
    this.navigationToggles = [
      ...this.context.querySelectorAll('[data-header="navigation-toggle"]'),
    ];
    this.subContainers = [...this.context.querySelectorAll('[data-header="sub-container"]')];
    this.subLists = [...this.context.querySelectorAll('[data-header="sub-list"]')];

    this.handleLevelToggleClick = this.handleLevelToggleClick.bind(this);
    this.handleNavigationToggleClick = this.handleNavigationToggleClick.bind(this);
    this.handleThirdLevelToggleClick = this.handleThirdLevelToggleClick.bind(this);

    this.activeLevelID = null;

    this.init();
  }

  init() {
    this.navigationToggles.forEach((navigationToggle) => {
      navigationToggle.addEventListener('click', this.handleNavigationToggleClick);
    });

    this.levelToggles.forEach((levelToggle) => {
      levelToggle.addEventListener('click', this.handleLevelToggleClick);
    });

    this.thirdLevelToggles.forEach((thirdLevelToggle) => {
      thirdLevelToggle.addEventListener('click', this.handleThirdLevelToggleClick);
    });

    const languageSwitchContainers = this.context.querySelectorAll('.language-switch-container');
    const currencySwitchContainers = this.context.querySelectorAll('.currency-switch-container');

    languageSwitchContainers.forEach((languageSwitchingMountPoint) => {
      if (!this.context.dataset.model) {
        console.error(
          "Error: Missing 'model' data attribute on the context element for language switching."
        );
        return;
      }

      try {
        const model = JSON.parse(this.context.dataset.model);
        const { cultures, culture, alternativeUrls, fallbackCulture } = model;

        if (!cultures || !culture || !alternativeUrls || !fallbackCulture) {
          console.error(
            "Error: Required data for language switching missing in the 'model' attribute."
          );
          return;
        }

        render(
          <LanguageSwitch
            cultures={cultures}
            currentCulture={culture}
            alternativeUrls={alternativeUrls}
            fallbackCulture={fallbackCulture}
          />,
          languageSwitchingMountPoint
        );
      } catch (error) {
        console.error("Error parsing JSON from 'model' data attribute:", error);
      }
    });

    currencySwitchContainers.forEach((currencySwitchingMountPoint) => {
      if (!this.context.dataset.model) {
        console.error(
          "Error: Missing 'model' data attribute on the context element for currency switching."
        );
        return;
      }

      try {
        const model = JSON.parse(this.context.dataset.model);
        const { currency, exchangeRates } = model;

        if (!currency || !exchangeRates) {
          console.error(
            "Error: Required data for currency switching missing in the 'model' attribute."
          );
          return;
        }

        render(
          <CurrencySwitch currency={currency} exchangeRates={exchangeRates} />,
          currencySwitchingMountPoint
        );
      } catch (error) {
        console.error("Error parsing JSON from 'model' data attribute:", error);
      }
    });
  }

  handleThirdLevelToggleClick(event) {
    const { currentTarget } = event;

    currentTarget.classList.toggle('active');
    this.calculateHeight();
  }

  handleLevelToggleClick(event) {
    const { currentTarget } = event;
    const { id } = currentTarget.dataset;

    // Close open level
    if (this.activeLevelID) {
      const subContainer = this.subContainers.find((c) => c.dataset.id === this.activeLevelID);
      subContainer.style.height = '0px';

      if (id === this.activeLevelID) {
        this.activeLevelID = null;
        return currentTarget.classList.remove('active');
      }

      const levelToggle = this.levelToggles.find((t) => t.dataset.id === this.activeLevelID);
      levelToggle.classList.remove('active');
    }

    // Open level
    this.activeLevelID = id;
    this.calculateHeight();

    return currentTarget.classList.add('active');
  }

  calculateHeight() {
    const subContainer = this.subContainers.find(
      (container) => container.dataset.id === this.activeLevelID
    );
    const subList = this.subLists.find((list) => list.dataset.id === this.activeLevelID);

    subContainer.style.height = `${subList.scrollHeight}px`;
  }

  handleNavigationToggleClick() {
    this.navigation.classList.toggle('active');
    document.body.classList.toggle('active-navigation');
  }
}
